import { Ref } from 'vue';

export type SetupProps = { uploadVideo: (video: File) => void };

export type VideoLoadError = Ref<{ title: string; description: string } | null>;
export const permissionDeniedMessage =
  "We didn't detect a camera, which means it is either being blocked by your browser, disabled by your device's security settings, used by another application, or is not functioning.\n\n" +
  'In most cases you can resolve this by clicking the camera icon in the address bar above and selecting "Always Allow" (You may need to refresh this page for the changes to take effect). Use the links below if that didn\'t work for you.';

export type SetupReturnType = {
  videoContainer: Ref<HTMLDivElement | null>;
  desktopVideoElement: Ref<HTMLVideoElement | null>;
  desktopRecordedVideoElement: Ref<HTMLVideoElement | null>;
  videoLoadError: VideoLoadError;
  isPaused: Ref<boolean>;
  countDown: Ref<number>;
  videoPreviewVisible: Ref<boolean>;
  videoInputDevices: Ref<{ deviceId: string; label: string }[]>;
  audioInputDevices: Ref<{ deviceId: string; label: string }[]>;
  isLoading: Ref<boolean>;
  isRecording: Ref<boolean>;
  videoLoaded: Ref<boolean>;
  handlePauseRecording: () => void;
  handleStopRecording: () => void;
  handleUploadRecording: () => void;
  startCountDownTimer: () => void;
  startNewRecording: () => void;
  handleCancelRecordingCountdown: () => void;
  handleVideoDeviceChanged: (e: Event) => Promise<void>;
  handleAudioDeviceChanged: (e: Event) => Promise<void>;
  loadVideo: (e: Event) => void;
  t: (key: string, strings?: string[]) => string;
  startButtonVisible: Ref<boolean>;
  resumeButtonVisible: Ref<boolean>;
  restartButtonVisible: Ref<boolean>;
  toggleSettings: (e: Event) => void;
  settingsVisible: Ref<boolean>;
  deviceOptions: Ref<HTMLDivElement | null>;
  handleAttachVideo: () => void;
  fileLoader: Ref<HTMLInputElement | null>;
  elapsedTime: Ref<string>;
  progress: Ref<number>;
  formattedVideoMaxDuration: Ref<string> | string;
  acceptedVideoTypes: string;
  downloadableRecordedVideoElement: Ref<HTMLAnchorElement | null>;
  userInformationNeeded: Ref<boolean>;
  isIframed: Ref<boolean>;
  showGuidelines: Ref<boolean>;
  iframeParentIsAdminApp: Ref<boolean>;
  clickWrapFeatureEnabled: Ref<boolean>;
};
